import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { CalculoService } from '@app/core/calculo.service';
import { FincaService } from '@app/core/finca.service';
import { ModuloService } from '@app/core/modulo.service';
import { Finca } from '@models/finca';
import { Module } from '@models/module';
import {
  HttpCriteria,
  SuperHttpClientProvider
} from '@app/core/http';
import { tap } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-calculos',
  templateUrl: './calculos.component.html',
  styleUrls: ['./calculos.component.scss']
})
export class CalculosComponent implements OnInit {
  private criteria: HttpCriteria = new HttpCriteria();
  private moduleCriteria: HttpCriteria = new HttpCriteria({ _perPage: -1, _page: -1 });

  public calculo: string = 'acumulados';
  public modulos: Module[] = [];
  public fincas: Finca[] = [];
  public isPrimerCalculo: boolean = false;

  public datosForm: UntypedFormGroup = new UntypedFormGroup({
    idModulo: new UntypedFormControl(''),
    dateInitial: new UntypedFormControl(''),
    dateFinal: new UntypedFormControl(''),
    caudal: new UntypedFormControl(null),
    temperaturaMaxima: new UntypedFormControl(''),
    temperaturaMinima: new UntypedFormControl(''),
    temperaturaMedia: new UntypedFormControl(''),
    viento: new UntypedFormControl(''),
    precipitacion: new UntypedFormControl(''),
    acumulado: new UntypedFormControl('')
  });

  constructor(
    private calculoService: CalculoService,
    private fincaService: FincaService,
    private moduloService: ModuloService
  ) {}

  ngOnInit() {
    this.getFincas();
    const today = new Date();
    const start = new Date(today);
    start.setDate(start.getDate() - 7);
    this.datosForm.get('dateInitial')?.setValue(start);
    this.datosForm.get('dateFinal')?.setValue(today);
  }

  private getModulos(idFinca: number) {
    this.moduleCriteria = new HttpCriteria({ _perPage: -1, _page: -1 });
    this.moduleCriteria.addFilter({
      field: 'idFinca',
      operator: '=',
      value: idFinca
    });

    this.moduloService
      .getModulos(this.moduleCriteria)
      .pipe(tap(m => (this.modulos = m)))
      .subscribe();
  }

  private getFincas() {
    this.fincaService
      .getFincas()
      .pipe(tap(f => (this.fincas = f)))
      .subscribe();
  }

  public cambiarCalculo(event: any) {
    this.calculo = event;
  }

  public recogerDatos() {
    let dateInitial = this.formatDate(this.datosForm.value.dateInitial);
    let dateFinal = this.formatDate(this.datosForm.value.dateFinal);

    if (
      this.datosForm.value.caudal === '' ||
      this.datosForm.value.caudal === null ||
      this.datosForm.value.caudal === 'null'
    ) {
      const item = {
        dateInitial: dateInitial,
        dateFinal: dateFinal,
        caudal: null
      };

      this.calculoService
        .realizarCalculo(this.datosForm.value.idModulo, item)
        .pipe(
          tap(d => {
            this.datosForm.get('temperaturaMaxima').setValue(d.tempData.tMax);
            this.datosForm.get('temperaturaMinima').setValue(d.tempData.tMin);
            this.datosForm.get('temperaturaMedia').setValue(d.tempData.tMed);
            this.datosForm.get('viento').setValue(d.windData);
            this.datosForm.get('precipitacion').setValue(d.rainData);
            this.datosForm.get('acumulado').setValue(d.contadorData);
            this.isPrimerCalculo = true;
          })
        )
        .subscribe();
    } else {
      const item = {
        dateInitial: dateInitial,
        dateFinal: dateFinal,
        caudal: this.datosForm.value.caudal
      };

      this.calculoService
        .realizarCalculo(this.datosForm.value.idModulo, item)
        .pipe(
          tap(d => {
            this.datosForm.get('temperaturaMaxima').setValue(d.tempData.tMax);
            this.datosForm.get('temperaturaMinima').setValue(d.tempData.tMin);
            this.datosForm.get('temperaturaMedia').setValue(d.tempData.tMed);
            this.datosForm.get('viento').setValue(d.windData);
            this.datosForm.get('precipitacion').setValue(d.rainData);
            this.datosForm.get('acumulado').setValue(d.contadorData);
            this.isPrimerCalculo = true;
          })
        )
        .subscribe();
    }
  }

  public changeCaudal() {
    let dateInitial = this.formatDate(this.datosForm.value.dateInitial);
    let dateFinal = this.formatDate(this.datosForm.value.dateFinal);

    if (this.datosForm.value.caudal === 'null') {
      const item = {
        dateInitial: dateInitial,
        dateFinal: dateFinal,
        caudal: null
      };

      this.calculoService
        .realizarCalculo(this.datosForm.value.idModulo, item)
        .pipe(
          tap(d => {
            this.datosForm.get('temperaturaMaxima').setValue(d.tempData.tMax);
            this.datosForm.get('temperaturaMinima').setValue(d.tempData.tMin);
            this.datosForm.get('temperaturaMedia').setValue(d.tempData.tMed);
            this.datosForm.get('viento').setValue(d.windData);
            this.datosForm.get('precipitacion').setValue(d.rainData);
            this.datosForm.get('acumulado').setValue(d.contadorData);
            this.isPrimerCalculo = true;
          })
        )
        .subscribe();
    } else {
      const item = {
        dateInitial: dateInitial,
        dateFinal: dateFinal,
        caudal: this.datosForm.value.caudal
      };

      this.calculoService
        .realizarCalculo(this.datosForm.value.idModulo, item)
        .pipe(
          tap(d => {
            this.datosForm.get('temperaturaMaxima').setValue(d.tempData.tMax);
            this.datosForm.get('temperaturaMinima').setValue(d.tempData.tMin);
            this.datosForm.get('temperaturaMedia').setValue(d.tempData.tMed);
            this.datosForm.get('viento').setValue(d.windData);
            this.datosForm.get('precipitacion').setValue(d.rainData);
            this.datosForm.get('acumulado').setValue(d.contadorData);
            this.isPrimerCalculo = true;
          })
        )
        .subscribe();
    }
  }

  public seleccionarFinca(event: any) {
    const idFinca = event?.value || parseInt(event?.target?.value || 0);
    if (!idFinca) return;
    this.datosForm.get('idModulo')?.reset('');
    this.getModulos(parseInt(idFinca));
  }

  public onRangeChange(range: { begin: Date | null; end: Date | null }) {
    this.datosForm.get('dateInitial')?.setValue(range?.begin || null);
    this.datosForm.get('dateFinal')?.setValue(range?.end || null);
  }

  private formatDate(date: any): string {
    if (!date) return '';
    const d = new Date(date);
    const yyyy = d.getFullYear();
    const mm = ('0' + (d.getMonth() + 1)).slice(-2);
    const dd = ('0' + d.getDate()).slice(-2);
    return `${yyyy}${mm}${dd}`;
  }
}
